import { useState, useEffect, useContext } from 'react';
import { MemberContext } from '../components/context';
import { combineValuesWithSepartors, getValuesFromDataObject } from '../utils/util';

const getVal = require('lodash/get');

const useDropDownOptions = (props) => {
  const {
    fetchUrl,
    isFieldOptionsToBeLookedUp,
    formContainer,
    fieldOptionsToBeLookedUpFrom,
    isDynamicPrefilledOptions,
    dynamicPrefilledWith,
    filledFormData,
    fieldOptions,
    fromStaticMetadataWithDynamicKey,
    fieldId,
    dataObject,
    fieldOptionObject = {
      type: 'default',
    },
    dynamicEntityDataOptions,
    entityData = {},
  } = props;

  const [options, setOptions] = useState([]);
  const memberContextVal = useContext(MemberContext);
  const extendedDataObject = { ...dataObject, memberContext: memberContextVal };
  const createOption = (label, value, accountToken = '') => ({ label, value, accountToken });

  /* eslint complexity: ["error", 30] -- need to increase complexity */
  useEffect(
    () => {
      if (fieldOptionObject.type === 'default') {
        if (fetchUrl) {
          setOptions(memberContextVal);
        } else if (isFieldOptionsToBeLookedUp) {
          if (
            formContainer
            && formContainer.operations
            && formContainer.operations[fieldOptionsToBeLookedUpFrom]
          ) {
            setOptions(formContainer.operations[fieldOptionsToBeLookedUpFrom]);
          }
        } else if (
          isDynamicPrefilledOptions
          && dynamicPrefilledWith === 'filledFormData'
        ) {
          const dynamicFieldOptions = [];
          if (filledFormData) {
            fieldOptions.forEach((option) => {
              const optiontObj = structuredClone(option);
              const optionArr = optiontObj.label;
              if (Array.isArray(optionArr)) {
                const labelStrArr = [];
                optionArr.forEach((dynamicFieldVal) => {
                  if (
                    filledFormData[dynamicFieldVal]
                    && filledFormData[dynamicFieldVal] !== ''
                  ) {
                    labelStrArr.push(filledFormData[dynamicFieldVal]);
                  }
                });
                if (labelStrArr.length > 0) {
                  optiontObj.label = labelStrArr.join(', ');
                  dynamicFieldOptions.push(optiontObj);
                }
              } else {
                dynamicFieldOptions.push(optiontObj);
              }
            });
          }
          setOptions(dynamicFieldOptions);
        } else if (dynamicEntityDataOptions) {
          const dynamicFieldOptions = [...fieldOptions];
          let index = dynamicFieldOptions.length;
          if (dynamicEntityDataOptions.tables) {
            dynamicEntityDataOptions.tables.forEach((table) => {
              if (entityData[table.tableName]) {
                entityData[table.tableName].forEach((data) => {
                  const value = table.valueKeys.map((key) => data[key]);
                  const id = `${index}-${value.join('-')}`.toLowerCase();
                  dynamicFieldOptions.push({
                    id,
                    label: table.labelKeys.map((key) => data[key]).join(table?.labelJoin || ' '),
                    value: value.join(table?.valueJoin || ' '),
                  });

                  dataObject.expandableTableData[value.join(table?.valueJoin || ' ')] = data;
                  dataObject.setExpandableTableData(dataObject.expandableTableData);
                  index += 1;
                });
              }
            });
          }

          if (dynamicEntityDataOptions.optinsFromPropertyKey) {
            dynamicEntityDataOptions.optinsFromPropertyKey.forEach((propertyKey) => {
              const value = getVal(filledFormData, propertyKey);
              const id = `${index}-${value}`.toLowerCase();
              dynamicFieldOptions.push({
                id,
                label: value,
                value,
              });
              index += 1;
            });
          }
          setOptions(dynamicFieldOptions);
        } else if (fromStaticMetadataWithDynamicKey) {
          setOptions(
            formContainer.staticMetadata?.[fieldId]?.[
              getVal(filledFormData, fromStaticMetadataWithDynamicKey)
            ]
          );
        } else {
          setOptions(fieldOptions);
        }
      } else if (fieldOptionObject.type === 'static') {
        setOptions(fieldOptionObject.fieldOptions);
      } else if (fieldOptionObject.type === 'suppCards') {
        const optns = getVal(dataObject, 'memberInfo.supplementaryAccounts') || [];
        setOptions(optns);
      } else if (fieldOptionObject.type === 'generateOptionsWithLabelsAndValues') {
        const generatedOptions = [];
        // if there's any default option ->
        if (fieldOptionObject?.optionStructure?.defaultLabel) {
          generatedOptions.push(
            createOption(fieldOptionObject?.optionStructure?.defaultLabel,
              fieldOptionObject?.optionStructure?.defaultValue));
        }
        let optionsData = [];
        if (fieldOptionObject.optionsFrom === 'allUserCards') {
          // all cards from memberContext
          memberContextVal.forEach((card) => {
            optionsData = [...optionsData, card];
            if (card?.supplementaryAccounts?.length > 0) {
              optionsData = [...optionsData, ...card.supplementaryAccounts];
            }
          });
        } else {
          optionsData = getVal(extendedDataObject, fieldOptionObject.optionsFrom) || [];
        }

        if (optionsData?.length > 0) {
          optionsData.forEach((optn) => {
            const label = combineValuesWithSepartors(
              getValuesFromDataObject(optn, fieldOptionObject?.optionStructure?.labelKeys),
              fieldOptionObject?.optionStructure?.labelSeparators
            );
            let value = '';
            if (fieldOptionObject?.optionStructure?.isValueSameAsLabel) {
              value = label;
            } else {
              value = combineValuesWithSepartors(
                getValuesFromDataObject(optn, fieldOptionObject?.optionStructure?.valueKeys),
                fieldOptionObject?.optionStructure?.valueSeparators
              );
            }
            generatedOptions.push(createOption(label, value));
          });
        }
        setOptions(generatedOptions);
      } else if (fieldOptionObject.type === 'mapOptionsBasedOnDependentValue') {
        // Dynamically creating dropdown options with a dependent value
        const dependsOnValue = getVal(dataObject, fieldOptionObject.dependsOn[0]) || '';
        const filteredOptions = fieldOptionObject.fieldOptions.filter((fieldOption) => {
          const { dependentValue } = fieldOption;
          return !dependentValue || dependentValue === dependsOnValue;
        });
        setOptions(filteredOptions);
      }
    },
    fieldOptionObject?.dependsOn?.reduce((deps, key) => {
      deps.push(getVal(dataObject, key));
      return deps;
    }, []) || []
  );

  return options;
};

export default useDropDownOptions;
